import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ImportNzIdWizardComponent } from './import-wizard/import-nz-id-wizard.component';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { MaterialModule } from '../common/material/material.module';
import { ServiceModule } from '../service/service.module';
import { FormsModule } from '@angular/forms';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { PipeModule } from '../common/pipe/pipe.module';
import { NzIdErrorCodeReadablePipe } from './nz-id-error-code-readable.pipe';
import { ImportReportDisplayComponent } from './importreport-display/import-report-display.component';
import { UploadFileFormComponent } from '../common/form/components/upload-form/upload-file-form.component';

@NgModule({
    imports: [
        CommonModule,
        MaterialModule,
        ServiceModule,
        FormsModule,
        MatProgressSpinnerModule,
        PipeModule,
        ImportReportDisplayComponent,
        UploadFileFormComponent,
        NzIdErrorCodeReadablePipe,
    ],
    declarations: [
        ImportNzIdWizardComponent,
    ],
    providers: [
        provideHttpClient(withInterceptorsFromDi()),
    ],
})
export class ImportNzIdWizardModule {
}
